import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ScheduleInterview.scss";
import { faAngleLeft, faClockRotateLeft, faQuoteLeft } from "@fortawesome/free-solid-svg-icons";
import { Calendar } from "antd";
import { faClockFour, faUser } from "@fortawesome/free-regular-svg-icons";
import useScheduleInterview from "./useScheduleInterview";
import { dateFormatter } from "../../../_helpers/dateFormatter";
import { formatAMPM } from "../../../_helpers/dateFormatter";

import MainLayout from "../MainLayout";
function ScheduleInterview(props) {
  const {
    formData,
    confirmTimeIndex,
    isTimeIntervalListActive,
    isScheduleEventForm,
    eventDetails,
    userMeta,
    timeIntervalList,
    isInterviewScheduled,
    scheduledEventDetails,

    onTimeClick,
    onDateSelect,
    onTimeConfirm,
    onTimeCancel,
    onBackClick,
    onFormInputChange,
    onScheduleEventConfirmClick,
    validateGoogleCalendarInterval,
    onCalendarBackClick,
    onJoinEventClick,
  } = useScheduleInterview(props);


  return (
    <MainLayout pageName={"Schedule Interview"}>
      <div className="schedule-inverviews-wrapper py-4">
        <div className="container ">
          {!isScheduleEventForm && !isInterviewScheduled ? (
            <>
              {" "}
              <div className="mb-3">
                {" "}
                <p
                  className="text-primary mb-3 cursor-pointer"
                  onClick={onCalendarBackClick}
                >
                  <FontAwesomeIcon icon={faAngleLeft} className="mr-2 mt-1" />
                  Back
                </p>
              </div>
            </>
          ) : (
            <>
              {!isInterviewScheduled && (
                <div className="mb-3">
                  {" "}
                  <p
                    className="text-primary mb-3 cursor-pointer"
                    onClick={onBackClick}
                  >
                    <FontAwesomeIcon icon={faAngleLeft} className="mr-2 mt-1" />
                    Back
                  </p>
                </div>
              )}
            </>
          )}

          <div className="schedule-inverviews-inner">
            {!isScheduleEventForm && !isInterviewScheduled && (
              <>
                <div className="row">
                  <div className="col-lg-3">
                    <div className="border border-radius-10 bg-white">
                      <div className="border-bottom p-3">
                        <h3 className="mb-0">Event Details</h3>
                      </div>
                      <div className="p-3">
                        <div className="d-flex align-items-start mb-3">
                          <div className="icon mr-2 text-primary">
                            <FontAwesomeIcon icon={faUser} />
                          </div>
                          <div className="content">
                            <p className="text-grey-4 mb-1">interviewer</p>
                            <p className="font-weight-medium">
                              {" "}
                              {eventDetails?.event_details &&
                                eventDetails.event_details?.event_creator &&
                                eventDetails.event_details.event_creator
                                  ?.full_name}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-start mb-3">
                          <div className="icon mr-2 text-primary">
                            <FontAwesomeIcon icon={faQuoteLeft} />
                          </div>
                          <div className="content">
                            <p className="text-grey-4 mb-1">Event</p>
                            <p className="font-weight-medium">
                              {eventDetails?.event_details &&
                                eventDetails.event_details?.title}
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-start">
                          <div className="icon mr-2 text-primary">
                            <FontAwesomeIcon icon={faClockFour} />
                          </div>
                          <div className="content mb-2">
                            <p className="text-grey-4 mb-1">Duration</p>
                            <p className="font-weight-medium">
                              {eventDetails?.event_details &&
                                eventDetails.event_details?.duration}{" "}
                              mins
                            </p>
                          </div>
                        </div>
                        <div className="d-flex align-items-start">
                          <div className="icon mr-2 text-primary">
                            <FontAwesomeIcon icon={faClockRotateLeft} />
                          </div>
                          <div className="content">
                            <p className="text-grey-4 mb-1">Scheduled Time</p>
                            <p className="font-weight-medium">
                              {scheduledEventDetails?.start_time && scheduledEventDetails.start_time.slice(0, 5)}
                              - {scheduledEventDetails?.end_time && scheduledEventDetails.end_time.slice(0, 5)}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg">
                    <div className="border border-radius-10 mt-4 mt-lg-0 bg-white">
                      <div className="border-bottom p-3">
                        <h3 className="mb-0">Select a date</h3>
                      </div>
                      <div className="p-3">
                        <div className="row">
                          <div className="col-lg">
                            <div className="calender-wrapper-box">
                              <div className="calender-wrapper">
                                <Calendar
                                  fullscreen={false}
                                  onSelect={onDateSelect}
                                />
                              </div>
                            </div>
                          </div>
                          {isTimeIntervalListActive && (
                            <div className="col-lg-4 full-height border-left">
                              <div className="availability-timing-wrapper mt-2">
                                <h3 className="my-3">Select a time</h3>
                                <ul className="availability-timing">
                                  {Array.isArray(timeIntervalList) &&
                                    timeIntervalList.length > 0 ? (
                                    <>
                                      {timeIntervalList.map((item, index) => (
                                        <li>
                                          {validateGoogleCalendarInterval(
                                            item
                                          ) ? (
                                            <button
                                              key={index}
                                              className={
                                                "btn btn-outline-secondary mt-2 w-100"
                                              }
                                              disabled
                                            >
                                              {item}
                                            </button>
                                          ) : (
                                            <button
                                              onClick={() => onTimeClick(index)}
                                              key={index}
                                              className={
                                                "time-slot-btn btn btn-outline-light mt-2"
                                              }
                                            >
                                              {item}
                                            </button>
                                          )}
                                          {confirmTimeIndex === index ? (
                                            <div className="action-btns p-0 mt-2 d-flex  align-items-center justify-content-center w-100">
                                              <button
                                                onClick={() =>
                                                  onTimeConfirm(item)
                                                }
                                                className={
                                                  "btn btn-primary py-2"
                                                }
                                              >
                                                Confirm
                                              </button>
                                              <button
                                                onClick={() => onTimeCancel()}
                                                className={
                                                  "btn btn-dark py-2 ml-2"
                                                }
                                              >
                                                Cancel
                                              </button>
                                            </div>
                                          ) : null}
                                        </li>
                                      ))}
                                    </>
                                  ) : (
                                    <p className="font-weight-medium">
                                      No availability set
                                    </p>
                                  )}
                                </ul>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}

            {/* next sreen  */}
            {isScheduleEventForm && (
              <div className="row no-gutters">
                <div className="col-lg-3">
                  <div className="border border-radius-10 bg-white">
                    <div className="border-bottom p-3">
                      <h3 className="mb-0">Event Details</h3>
                    </div>
                    <div className="p-3">
                      <div className="d-flex align-items-start mb-3">
                        <div className="icon mr-2 text-primary">
                          <FontAwesomeIcon icon={faUser} />
                        </div>
                        <div className="content">
                          <p className="text-grey-4 mb-1">interviewer</p>
                          <p className="font-weight-medium">
                            {" "}
                            {eventDetails?.event_details &&
                              eventDetails.event_details?.event_creator &&
                              eventDetails.event_details.event_creator
                                ?.full_name}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-start mb-3">
                        <div className="icon mr-2 text-primary">
                          <FontAwesomeIcon icon={faQuoteLeft} />
                        </div>
                        <div className="content">
                          <p className="text-grey-4 mb-1">Event</p>
                          <p className="font-weight-medium">
                            {eventDetails?.event_details &&
                              eventDetails.event_details?.title}
                          </p>
                        </div>
                      </div>
                      <div className="d-flex align-items-start">
                        <div className="icon mr-2 text-primary">
                          <FontAwesomeIcon icon={faClockFour} />
                        </div>
                        <div className="content">
                          <p className="text-grey-4 mb-1"> Duration</p>
                          <p className="font-weight-medium">
                            {eventDetails?.event_details &&
                              eventDetails.event_details?.duration}{" "}
                            mins
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="d-flex align-items-start pl-3">
                      <div className="icon mr-2 text-primary">
                        <FontAwesomeIcon icon={faClockRotateLeft} />
                      </div>
                      <div className="content">
                        <p className="text-grey-4 mb-1">Scheduled Time</p>
                        <p className="font-weight-medium">
                          {scheduledEventDetails?.start_time && scheduledEventDetails.start_time.slice(0, 5)}
                          - {scheduledEventDetails?.end_time && scheduledEventDetails.end_time.slice(0, 5)}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg bg-white border border-radius-10 ml-lg-4 mt-3 mt-lg-0 py">
                  <div className="border-bottom p-3">
                    <h3 className="mb-0">Enter Details</h3>
                  </div>
                  <div className="row p-3">
                    <div className="col-lg-7">
                      <div className="form-group">
                        <label htmlFor="" className="mb-2 font-weight-medium">
                          Please enter your name
                        </label>
                        {formData?.candidate_job_applicationn ||
                          userMeta?.id ? (
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Your Name"
                            name="name"
                            defaultValue={userMeta?.full_name}
                            disabled
                          />
                        ) : (
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Your Name"
                            name="name"
                            onChange={onFormInputChange}
                          />
                        )}
                      </div>
                    </div>

                    <div className="col-lg-7">
                      <div className="form-group">
                        <label htmlFor="" className="mb-2 font-weight-medium">
                          Please enter your email.
                        </label>
                        {formData?.candidate_job_application || userMeta?.id ? (
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Your Email"
                            name="email"
                            defaultValue={userMeta?.email}
                            disabled
                          />
                        ) : (
                          <input
                            type="text"
                            className="form-control"
                            placeholder="Your Email"
                            name="email"
                            onChange={onFormInputChange}
                          />
                        )}
                      </div>
                    </div>
                    <div className="col-lg-7">
                      <div className="form-group">
                        <label htmlFor="" className="mb-2 font-weight-medium">
                          Please share any additional note before meeting.
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Additional Note"
                          name="additional_note"
                          onChange={onFormInputChange}
                        />
                      </div>
                    </div>

                    <div className="col-lg-7">
                      <button
                        className="btn btn-primary"
                        onClick={onScheduleEventConfirmClick}
                      >
                        Schedule Event
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            )}

            {isInterviewScheduled && (
              <div className="row justify-content-center align-item-center no-gutters">
                <div className="col-xl-4 col-10 col-md-6">
                  <div className="border my-5 px-4 py-5 border-radius-10 bg-white text-center shadow-sm">
                    <div className="text-align-center">
                      <div className="success-img mb-3">
                        <img src={"./assets/images/Tick.png"} alt="success" />
                      </div>
                    </div>
                    <h3 className="mb-2">This meeting is scheduled</h3>
                    <p className="text-grey-4 border-bottom pb-4">
                      A calendar invitation has been sent to your email address.
                    </p>

                    <div className="text-left mt-4 font-weight-medium">
                      <div className="row mb-3">
                        <div className="col-3">
                          <span className="text-grey-4">What</span>
                        </div>
                        <div className="col-9">
                          <span>
                            {scheduledEventDetails?.event_details &&
                              scheduledEventDetails.event_details
                                ?.duration}{" "}
                            Min Meeting between You and{" "}
                            {scheduledEventDetails?.event_details &&
                              scheduledEventDetails.event_details
                                ?.event_creator &&
                              scheduledEventDetails.event_details.event_creator
                                ?.full_name}
                          </span>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-3">
                          <span className="text-grey-4">When</span>
                        </div>
                        <div className="col-9">
                          <span className="d-block">
                            {dateFormatter(
                              scheduledEventDetails &&
                              scheduledEventDetails?.in_user_timezone && scheduledEventDetails.in_user_timezone?.interview_date
                            )}
                          </span>
                          <span className="d-block">
                            {formatAMPM(
                              scheduledEventDetails &&
                              scheduledEventDetails?.in_user_timezone && scheduledEventDetails.in_user_timezone?.start_time
                            )}{" "}
                            -
                            {formatAMPM(
                              scheduledEventDetails &&
                              scheduledEventDetails?.in_user_timezone && scheduledEventDetails.in_user_timezone?.end_time
                            )}
                          </span>
                        </div>
                      </div>
                    </div>

                    <button
                      className="btn btn-primary mt-5 px-5"
                      onClick={onJoinEventClick}
                    >
                      Join Event
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </MainLayout>
  );
}

export default ScheduleInterview;
